angular.module('app').component('adminAccordion', {
    templateUrl: 'events/components/accordion.html',
    transclude: {
        actions: '?adminAccordionActions'
    },
    bindings: {
        actionsVisible: '<?',
        icon: '@',
        initiallyExpanded: '<?',
        title: '@'
    },
    controller: ['$scope', '$timeout', '$transclude', function($scope, $timeout, $transclude) {
        var main = this;

        main.expanded = false;
        main.hasActions = $transclude.isSlotFilled('actions');

        function expand() {
            main.expanded = true;

            $timeout(function() {
                $scope.$broadcast('md-resize-textarea');
            }, 0, false);
        }

        function collapse() {
            main.expanded = false;
        }

        main.$onInit = function() {
            var state = {title: main.title, expanded: !!main.initiallyExpanded};
            $scope.$emit('adminAccordion:initialize', state);
            if (state.expanded) {
                expand();
            }
        };

        $scope.$on('adminAccordion:collectState', function(event, state) {
            state[main.title] = main.expanded;
        });

        main.toggle = function() {
            if (main.expanded) {
                collapse();
            } else {
                expand();
            }
        };

        $scope.$on('adminAccordion:expandAll', function() {
            expand();
        });

        $scope.$on('adminAccordion:collapseAll', function() {
            collapse();
        });

        $scope.$on('adminAccordion:expand', function(event, title) {
            if (!title || title === main.title) {
                expand();
            }
        });
    }]
});
